//let indexesToRemove: Array<number>;
//let namesToRemove: Array<string>;
//let overrideDateValidation: boolean;

module ExternalWebCourseCenterBooking {
    function NewAlert(type: string, message: string, hideAfterDisplay?: boolean, $targetParentDiv?: JQuery, $targetBodyDiv?: JQuery, clearPreviousAlerts: boolean = true): void {
        if (typeof hideAfterDisplay === "undefined") { hideAfterDisplay = true; }
        if ($targetParentDiv != null && $targetParentDiv != undefined && $targetBodyDiv != null && $targetBodyDiv != undefined) {
        } else {
            $targetParentDiv = $("#alertarea-parent" + cpaccipf());
            $targetBodyDiv = $("#alertarea-body" + cpaccipf());
        }

        if (clearPreviousAlerts == true) {
            HideAlert($targetParentDiv, $targetBodyDiv);
            $targetBodyDiv.append($("<div class='alert alert-message alert-" + type + " role='alert'><span> " + message + " </span></div>")).css("display", "block");
            $targetParentDiv.css("display", "block");
        }
        else {
            $targetBodyDiv.append($("<div class='alert alert-message alert-" + type + " role='alert'><span> " + message + " </span></div>")).delay(400).fadeIn('fast');
            $targetParentDiv.slideDown('fast').animate({ opacity: 1, queue: false, duration: 'fast' });
        }

        if (hideAfterDisplay == true) {
            $targetBodyDiv.delay(4600).fadeOut('fast');
            $targetParentDiv.delay(5000).slideUp('fast', function () {
                $targetBodyDiv.empty();
                $targetParentDiv.css('display', 'none');
            }).animate({ opacity: 1, queue: false, duration: 'fast' });
        }
    }

    function HideAlert($targetParentDiv?: JQuery, $targetBodyDiv?: JQuery): void {
        if ($targetParentDiv != null && $targetParentDiv != undefined && $targetBodyDiv != null && $targetBodyDiv != undefined) {
        } else {
            $targetParentDiv = $("#alertarea-parent");
            $targetBodyDiv = $("#alertarea-body");
        }

        $targetBodyDiv.empty();
        $targetParentDiv.css('display', 'none');
    }

    class CourseCenterParticipant {
        constructor(
            public FirstName: string,
            public LastName: string,
            public CompanyName: string,
            public DateOfBirth: string,
            public PersonalNumber: string,
            public Address: string,
            public ZipCode: string,
            public City: string,
            public CountryId: number,
            public RegionIds: number[],
            public Email: string,
            public Phone: string,
            public Notes: string,
            public IsTravelAndAccommodationOrdered?: boolean,
            public _Index?: number) {
        }
    }

    let courseCenterParticipants: Array<CourseCenterParticipant> = new Array<CourseCenterParticipant>();

    export function AddParticipant(): void {
        var form = $("#divBookingForOthers").find("form");

        form.validate();

        if (form.valid()) {
            var dynamicField = "";

            if ($("#txtParticipantVessel").length > 0) {
                dynamicField = String($("#txtParticipantVessel").val());
            }

            courseCenterParticipants.push(new CourseCenterParticipant(/*firstName*/ String($("#Participants_0__FirstName").val()), /*lastName*/ String($("#Participants_0__LastName").val()),
                /*companyName*/ String($("#Participants_0__CompanyName").val()), /*dateOfBirthText*/ String($("#Participants_0__DateOfBirth").val()), /* personalNumber */ String($("#Participants_0__PersonalNumber").val()),
                /*address*/ String($("#Participants_0__Address").val()), /*zipCode*/ String($("#Participants_0__ZipCode").val()), /*city*/ String($("#Participants_0__City").val()),
                /*countryId*/ Number($("#ddlParticipantCountries").val()), /*RegionIds*/ ($("#Participants_0__RegionIds").select2("val" as any) as any), /*email*/ String($("#Participants_0__Email").val()),
                /*phoneNumber*/ String($("#Participants_0__Phone").val()), /*notes*/ String($("#Participants_0__Notes").val()),
                /*TravelAndAccommodationOrdered?*/ $("#chkbxTravelAndAccommodationOthers").is(":checked"),
                new Date().getUTCMilliseconds()));

            ResetAddParticipantForm();

            var participants = form.find('.participantsHidden');

            participants.remove();

            $.each(courseCenterParticipants, function (index: number, value: CourseCenterParticipant) {
                form.append('<input type="hidden" name="Participants[' + index + '].CompanyName" value="' + value.CompanyName + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].FirstName" value="' + value.FirstName + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].LastName" value="' + value.LastName + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].Phone" value="' + value.Phone + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].Email" value="' + value.Email + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].DateOfBirth" value="' + value.DateOfBirth + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].PersonalNumber" value="' + value.PersonalNumber + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].Address" value="' + value.Address + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].City" value="' + value.City + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].ZipCode" value="' + value.ZipCode + '" class="participantsHidden" />');
                form.append('<input type="hidden" name="Participants[' + index + '].CountryId" value="' + value.CountryId + '" class="participantsHidden" />');

                $.each(value.RegionIds, function (regionIndex: number, region: number) {
                    form.append('<input type="hidden" name="Participants[' + index + '].RegionIds[' + regionIndex+']" value="' + region + '" class="participantsHidden" />');
                });

                form.append('<input type="hidden" name="Participants[' + index + '].IsTravelAndAccommodationOrdered" value="' + value.IsTravelAndAccommodationOrdered + '" class="participantsHidden" />');

                form.append('<input type="hidden" name="Participants[' + index + '].Notes" value="' + value.Notes + '" class="participantsHidden" />');
            });
        }

        RenderParticipantsTable();

        let hasParticipants: boolean = courseCenterParticipants && courseCenterParticipants.length > 0;

        ExternalWebScripts.EnableOrDisableBookButton(hasParticipants ? true : false);
    }

    function validateAddParticipantForm(showAlertsAndHighlightFields: boolean): boolean {

        let $modalBookingForm: JQuery = $("#modalBookingForm");
        let $divParticipants: JQuery = $modalBookingForm.find("#divParticipants");

        let isValid = true,
            allRequiredFieldsFilled = true,
            duplicateParticipant = false,
            coordinatorEmailUsedWithWrongInfo = false;
        let validationSummaryMessages = new Array();
        let $requiredFields: JQuery
            = $divParticipants.find("[required='required']");

        $divParticipants.find("[required='required']").removeClass("border-danger");

        jQuery.each($requiredFields, function () {

            let isThisFieldFilled = true;
            let $this: JQuery = $(this);

            if ((($this.get(0) instanceof HTMLInputElement && ($this.attr("type") == "text" || $this.attr("type") == "password" || $this.attr("type") == "date" || $this.attr("type") == "tel"))
                    || $this.get(0) instanceof HTMLTextAreaElement)
                && !CommonScripts.CheckIfTextInputHasValue(<HTMLInputElement>$this.get(0))
            ) {

                isThisFieldFilled = false;

            }
            else if ($this.get(0) instanceof HTMLInputElement && $this.attr("type") == "email"
                && !CommonScripts.CheckIfEmailInputHasValidEmailAddress(<HTMLInputElement>$this.get(0))) {

                isThisFieldFilled = false;

            }
            else if ($this.get(0) instanceof HTMLInputElement && $this.attr("type") == "number"
                && !CommonScripts.CheckIfInputHasNumericValue(<HTMLInputElement>$this.get(0))) {

                isThisFieldFilled = false;

            }
            else if ($this.get(0) instanceof HTMLInputElement && $this.attr("type") == "file") {

                var hdnInput = "hdnInput" + $this.attr("name");
                if (+$modalBookingForm.find("#" + hdnInput).val() <= 0
                    && !CommonScripts.CheckIfFileInputHasFileSelected(<HTMLInputElement>$this.get(0))) {
                    isThisFieldFilled = false;
                }

            }
            else if ($this.get(0) instanceof HTMLSelectElement
                && !CommonScripts.CheckIfSelectHasValueSelected(<HTMLSelectElement>$this.get(0))) {

                isThisFieldFilled = false;

            }

            if (!isThisFieldFilled /*&& showAlertsAndHighlightFields*/)
                $this.addClass("border-danger");
            else
                $this.removeClass("border-danger");

            allRequiredFieldsFilled = allRequiredFieldsFilled && isThisFieldFilled;

        });

        if (!allRequiredFieldsFilled)

            validationSummaryMessages.push("&nbsp;&bull;&nbsp;" + RESOURCES.TEXTS.EnterDataInAllMandatoryFieldsText);

        else {

            for (let i: number = 0; i < courseCenterParticipants.length; i++) {

                let participant: CourseCenterParticipant = courseCenterParticipants[i];

                if (($.trim(participant.LastName.toLowerCase()) == $.trim(String($("#txtParticipantLastName").val()).toLowerCase()))
                    && ($.trim(participant.DateOfBirth.toLowerCase()) == $.trim(String($("#txtParticipantDOB").val()).toLowerCase()))
                    && ($.trim(participant.Phone.toLowerCase()) == $.trim(String($("#txtParticipantPhone").val()).toLowerCase()))
                    /*&& $.trim(participant.FirstName.toLowerCase()) == $.trim($("#txtParticipantFirstName").val().toLowerCase())
                    && $.trim(participant.LastName.toLowerCase()) == $.trim($("#txtParticipantLastName").val().toLowerCase())*/) {

                    duplicateParticipant = true;
                    break;

                }
            }

            if (duplicateParticipant)
                validationSummaryMessages.push("&nbsp;&bull;&nbsp;" + RESOURCES.TEXTS.ParticipantHasAlreadyBeenAddedText);

            coordinatorEmailUsedWithWrongInfo = $.trim(String($("#txtParticipantEmail").val())) !== "" && $.trim(String($("#txtCoordinatorEmail").val()).toLowerCase()) == $.trim(String($("#txtParticipantEmail").val()).toLowerCase())
                && $.trim(String($("#txtCoordinatorLastName").val()).toLowerCase()) != $.trim(String($("#txtParticipantLastName").val()).toLowerCase());

            if (coordinatorEmailUsedWithWrongInfo)
                validationSummaryMessages.push("&nbsp;&bull;&nbsp;" + RESOURCES.TEXTS.TheCoordinatorAndTheParticipantHaveSameEmailButDifferentNamesText);

        }

        isValid = allRequiredFieldsFilled && !duplicateParticipant && !coordinatorEmailUsedWithWrongInfo;
        if (!isValid && showAlertsAndHighlightFields) {
            CommonScripts.NewAlert("danger", validationSummaryMessages.join("<br />"), true, $("#alertAreaParentParticipants"), $("#alertAreaBodyParticipants"));
        }
        else {
            //UpdateValidationSummary();
        }

        return isValid;
    }

    function validateParticipantsForm(showAlertsAndHighlightFields: boolean): boolean {

        // Method to check if participants exist and all participants data is saved (i.e. no unsaved data in participant form)
        let $modalBookingForm: JQuery = $("#modalBookingForm");
        let $divBookingForOthers: JQuery = $modalBookingForm.find("#divBookingForOthers");

        let isOthersForm: boolean = $divBookingForOthers.hasClass("in");

        if (isOthersForm) {
            let isValid = true,
                hasParticipants = false,
                allDataSaved = true;

            let validationSummaryMessages = new Array();

            hasParticipants = courseCenterParticipants != null && courseCenterParticipants.length > 0;

            if (!hasParticipants) {
                // If no participants, no need to check the form for unsaved data                
            } else if (hasParticipants) {
                let $divParticipants: JQuery = $modalBookingForm.find("#divParticipants");

                let $requiredFields
                    = $divParticipants.find("[required='required']");

                //$requiredFields.removeClass("border-danger");

                jQuery.each($requiredFields, function () {

                    let hasThisFieldData = true;
                    let $this: JQuery = $(this);

                    if (($this.get(0) instanceof HTMLInputElement && ($this.attr("type") == "text" || $this.attr("type") == "password" || $this.attr("type") == "date" || $this.attr("type") == "tel" || $this.attr("type") == "email" || $this.attr("type") == "number"))
                        || $this.get(0) instanceof HTMLTextAreaElement) {

                        hasThisFieldData = CommonScripts.CheckIfTextInputHasValue(<HTMLInputElement>$this.get(0), false);

                    }

                    if ($this.get(0) instanceof HTMLSelectElement && ($this.hasClass('select2-multiple'))) {
                        hasThisFieldData = $('.select2-selection__choice').length > 0;
                    }

                    allDataSaved = allDataSaved && !hasThisFieldData;

                });

            }

            if (!hasParticipants || !allDataSaved)
                validationSummaryMessages.push("&nbsp;&bull;&nbsp;" + RESOURCES.TEXTS.YouMustSaveParticipantToListToProceedWithBookingText);

            isValid = hasParticipants && allDataSaved;

            if (!isValid && showAlertsAndHighlightFields) {
                CommonScripts.NewAlert("danger", validationSummaryMessages.join("<br />"), true, $("#alertAreaParentParticipants"), $("#alertAreaBodyParticipants"));
            }
            else {

            }

            return isValid;
        }
        else {
            return true;
        }
    }

    function ResetAddParticipantForm() {
        let $modalBookingForm: JQuery = $("#modalBookingForm");
        let $divParticipants: JQuery = $modalBookingForm.find("#divParticipants");

        $('#ddlRegions').val(null).trigger('change');

        $divParticipants.find("input").each(function (i: number, element: any) {
            $(this).val(null).removeClass("border-danger");
        });

        $divParticipants.find("textarea").each(function (i: number, element: any) {
            $(this).val(null);
        });

        $("#chkbxTravelAndAccommodationOthers").removeAttr("checked");

        $divParticipants.find("input").first().focus();
    }

    function RenderParticipantsTable(): void {

        var $tblParticipants: JQuery = $("#tblParticipants");
        var $divParticipantsForm: JQuery = $("#divParticipantsForm");
        var $tBody: JQuery = $tblParticipants.find("tbody");
        var $trTemplate: JQuery = $tblParticipants.find("tr#trTemplate");

        $tBody.empty();
        $tBody.append($trTemplate);

        if (courseCenterParticipants && courseCenterParticipants.length > 0) {
            $tblParticipants.removeClass("d-none");

            for (let participant of courseCenterParticipants) {
                $tblParticipants.append(CreateParticipantTr(participant));
                if (participant.IsTravelAndAccommodationOrdered)
                    $tblParticipants.find("tr[data-participant-index='" + participant._Index + "']").find(".chkbxTravelAndAccommodationCourseCenterParticipant").attr("checked", "checked");
            }

            //$(".tdTravelAndAccommodationPdf").attr("rowspan", Participants.length);

            let nbrOfSeats: number = +$("#modalBookingForm").find("#hdnNbrOfSeats").val();
            let isWaitingList: boolean = (String($("#modalBookingForm").find("#hdnIsWaitingList").val()).toLowerCase() == "true");
            if (!isWaitingList && courseCenterParticipants.length >= maxNbrOfParticipants) {
                $divParticipantsForm.addClass("d-none");
                if (maxNbrOfParticipants < nbrOfSeats)
                    CommonScripts.NewAlert("info", RESOURCES.TEXTS.ItsNotPossibleToAddMoreThanNUMBERParticipantsAtATimeText.replace("{%NUMBER%}", maxNbrOfParticipants), true, $("#alertAreaParentParticipants"), $("#alertAreaBodyParticipants"));
            }
            else
                $divParticipantsForm.removeClass("d-none");
        }
        else {
            $tblParticipants.addClass("d-none");
            $divParticipantsForm.removeClass("d-none");
        }

        ExternalWebScripts.EnableOrDisableBookButton(false);

    }

    function CreateParticipantTr(participant: CourseCenterParticipant): string {

        var trParticipantHtml: string;

        if (participant && participant._Index > 0 && participant.FirstName.length > 0 && participant.LastName.length > 0 && participant.DateOfBirth.length > 0 && participant.Phone.length > 0) {

            var $tblParticipants: JQuery = $("#tblParticipants");
            var $trNewParticipant: JQuery = $tblParticipants.find("tr#trTemplate").clone();

            $trNewParticipant.removeAttr("id").removeClass("d-none").attr("data-participant-index", participant._Index);

            //if (participant._Index > 1) {
            //    $trNewParticipant.find(".tdTravelAndAccommodationPdf").remove();
            //}

            let $tdNotes: JQuery = $trNewParticipant.find(".tdNotes");
            let $iNotes: JQuery = $tdNotes.find("i");
            if (participant.Notes && participant.Notes.length > 0) {
                $iNotes.attr("data-content", participant.Notes)
                    .removeClass("far").addClass("fas");
            }
            else {
                $iNotes.attr("data-content", RESOURCES.TEXTS.NoneText)
                    .removeClass("fas").addClass("far");
            }

            if (participant.IsTravelAndAccommodationOrdered) {
                $trNewParticipant.find(".chkbxTravelAndAccommodationCourseCenterParticipant").attr("checked", "checked");
            }

            trParticipantHtml = $trNewParticipant.clone().wrap('<p>').parent().html();

            const rowIndex = $("#tblParticipants tr").length - 1;

            trParticipantHtml = trParticipantHtml.replace("{%SERIALNBR%}", rowIndex.toString());
            trParticipantHtml = trParticipantHtml.replace("{%FIRSTNAME%}", participant.FirstName);
            trParticipantHtml = trParticipantHtml.replace("{%LASTNAME%}", participant.LastName);
            trParticipantHtml = trParticipantHtml.replace("{%DATEOFBIRTH%}", participant.DateOfBirth);
            trParticipantHtml = trParticipantHtml.replace("{%PHONE%}", participant.Phone);
        }

        return trParticipantHtml;
    }

    export function UpdateCourseCenterParticipant(participantIndex: number, isTravelAndAccommodationOrdered: boolean): void {

        for (var i: number = 0; i < courseCenterParticipants.length; i++)
        {
            if (courseCenterParticipants[i]._Index == participantIndex) {
                courseCenterParticipants[i].IsTravelAndAccommodationOrdered = isTravelAndAccommodationOrdered;
                break;
            }
        }

        var form = $("#divBookingForOthers form");
        var participants = form.find('.participantsHidden');

        participants.remove();

        $.each(courseCenterParticipants, function (index: number, value: CourseCenterParticipant) {
            form.append('<input type="hidden" name="Participants[' + index + '].CompanyName" value="' + value.CompanyName + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].FirstName" value="' + value.FirstName + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].LastName" value="' + value.LastName + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].Phone" value="' + value.Phone + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].Email" value="' + value.Email + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].DateOfBirth" value="' + value.DateOfBirth + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].PersonalNumber" value="' + value.PersonalNumber + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].Address" value="' + value.Address + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].City" value="' + value.City + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].ZipCode" value="' + value.ZipCode + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].CountryId" value="' + value.CountryId + '" class="participantsHidden" />');

            $.each(value.RegionIds, function (regionIndex: number, region: number) {
                form.append('<input type="hidden" name="Participants[' + index + '].RegionIds[' + regionIndex + ']" value="' + region + '" class="participantsHidden" />');
            });

            form.append('<input type="hidden" name="Participants[' + index + '].IsTravelAndAccommodationOrdered" value="' + value.IsTravelAndAccommodationOrdered + '" class="participantsHidden" />');

            form.append('<input type="hidden" name="Participants[' + index + '].Notes" value="' + value.Notes + '" class="participantsHidden" />');
        });
    }

    export function DeleteCourseCenterParticipant(participantIndex: number): void {

        //var $tblParticipants: JQuery = $("#tblParticipants");
        //$tblParticipants.remove("tr[data-participant-index=" + participantIndex + "]");

        for (var i: number = 0; i < courseCenterParticipants.length; i++)
            if (courseCenterParticipants[i]._Index == participantIndex) {
                courseCenterParticipants.splice(i, 1);
                break;
            }

        RenderParticipantsTable();

        var form = $("#divBookingForOthers form");
        var participants = form.find('.participantsHidden');

        participants.remove();

        $.each(courseCenterParticipants, function (index: number, value: CourseCenterParticipant) {
            form.append('<input type="hidden" name="Participants[' + index + '].CompanyName" value="' + value.CompanyName + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].FirstName" value="' + value.FirstName + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].LastName" value="' + value.LastName + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].Phone" value="' + value.Phone + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].Email" value="' + value.Email + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].DateOfBirth" value="' + value.DateOfBirth + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].PersonalNumber" value="' + value.PersonalNumber + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].Address" value="' + value.Address + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].City" value="' + value.City + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].ZipCode" value="' + value.ZipCode + '" class="participantsHidden" />');
            form.append('<input type="hidden" name="Participants[' + index + '].CountryId" value="' + value.CountryId + '" class="participantsHidden" />');

            $.each(value.RegionIds, function (regionIndex: number, region: number) {
                form.append('<input type="hidden" name="Participants[' + index + '].RegionIds[' + regionIndex + ']" value="' + region + '" class="participantsHidden" />');
            });

            form.append('<input type="hidden" name="Participants[' + index + '].IsTravelAndAccommodationOrdered" value="' + value.IsTravelAndAccommodationOrdered + '" class="participantsHidden" />');

            form.append('<input type="hidden" name="Participants[' + index + '].Notes" value="' + value.Notes + '" class="participantsHidden" />');
        });

    }

    export function SaveBookingForm(addToWaitingList: boolean, sender: Object): void {
        if (ExternalWebScripts.ValidateTermsAndConditions(false)) {

            var $modalBookingForm: JQuery = $("#modalBookingForm");
            var $divBookingForSelf: JQuery = $modalBookingForm.find("#divBookingForSelf");
            var $divBookingForOthers: JQuery = $modalBookingForm.find("#divBookingForOthers");

            let activityId: number = +$modalBookingForm.find("#hdnActivityId").val();
            if (activityId < 0)
                activityId = null;

            if ($divBookingForSelf.hasClass("show")) {
                var form = $divBookingForSelf.find('form');

                form.submit();
            }
            else if ($divBookingForOthers.hasClass("show")) {
                var form = $divBookingForOthers.find("form");
                var participantInputs = form.find('#divParticipants input, #divParticipants textarea');

                indexesToRemove = [];
                namesToRemove = [];

                var validator = $("#myForm").data('validator');

                participantInputs.each(function (index: number, element: any) {
                    if ($(element).rules("remove", "required").required) {
                        indexesToRemove.push(index);
                    }
                    namesToRemove.push($(element).attr("name"));
                    $(element).removeAttr("name");
                });

                $("#divParticipantsForm input").removeClass("input-validation-error");
                $("#divParticipantsForm .field-validation-error").addClass("field-validation-valid").removeClass("field-validation-error");

                overrideDateValidation = true;

                form.validate();

                if (form.valid()) {
                    form.submit();
                }

                if (indexesToRemove.length > 0 && namesToRemove.length > 0) {
                    participantInputs.each(function (index, element) {
                        $(element).attr("name", namesToRemove[index]);
                        if (index == indexesToRemove[index]) {
                            $(element).rules("add", "required");
                        }
                    });
                }

                indexesToRemove = [];
                namesToRemove = [];
                overrideDateValidation = false;
            }
        }
    }
}